<nb-badge
	[text]="value"
	[status]="status"
	position="centered"
	class="badge"
></nb-badge>
